import React from "react";
import "./App.css";
import "./Design.css";
import "./DataScience.css";
import "./DataMarketing.css";
import "./EditableField.css";
import Home from "./component/Home";
import { Route, BrowserRouter as Router, Switch, Link } from "react-router-dom";
import About from "./component/About";
import WebDev from "./component/WebDev";
import DataScience from "./component/DataScience";
import DataMarketing from "./component/DataMarketing";
import Design from "./component/Design";



class App extends React.Component {
  render() {
    return (
      <div className="App">
        <Router>
          <Switch>
            <Route component={Home} exact path="/" />
            <Route component={About} exact path="/about" />
            <Route component={WebDev} exact path="/webdev/:subpage?" />
            <Route
              component={DataScience}
              exact
              path="/datascience/:subpage?"
            />
            <Route
              component={DataMarketing}
              exact
              path="/datamarketing/:subpage?"
            />
            <Route component={Design} exact path="/design/:subpage?" />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
